import React from "react";
import { Button, Col, Form } from "react-bootstrap";

const ORProjectionFacilityForm = (props) => {
  function handleSubmit(e) {
    e.preventDefault();

    const form = e.target;
    const data = form.elements;

    props.handleSubmit(data.facilityCurprev.value);
  }

  function handleReset(e) {
    const curprevSelect = document.getElementById("facilityCurprev");
    curprevSelect.selectedIndex = 0;
  }

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Row>
        <Col className="col-lg-9 col-12">
          <Form.Row>
            <Form.Group
              as={Col}
              controlId="facilityCurprev"
              className="col-lg-3 col-sm-4"
            >
              <Form.Label>Current or Previous Quarter</Form.Label>
              <Form.Control as="select" required>
                <option value="">Select Current or Previous</option>
                <option value="CURRENT">Current</option>
                <option value="PREVIOUS">Previous</option>
                <option value="PRIOR PREVIOUS">Prior Previous</option>
              </Form.Control>
            </Form.Group>
            <Col
              className="col-lg-1 col-sm-2 col-12 reset-wrap"
              style={{
                marginTop: "2.3%",
              }}
            >
              {/* <label>&nbsp;</label> */}
              <Button onClick={handleReset} className="reset-btn">
                <i className="fa fa-undo"></i> Reset
              </Button>
            </Col>
            <Col
              className="col-lg-2 col-sm-2 col-12"
              style={{
                marginTop: "2.3%",
              }}
            >
              <Form.Label>&nbsp;</Form.Label>
              <Button type="submit" className="results">
                Show Results
              </Button>
            </Col>
          </Form.Row>
        </Col>
      </Form.Row>
    </Form>
  );
};

export default ORProjectionFacilityForm;
